/*
 * @Author: HANG ZHANG
 * @Date: 2020-05-11 18:05:21
 * @Description: 激励视频代码位分发模块
 * @FilePath: /vision-h5/src/lib/reward_video.js
 */
import { compatibleShowVideo } from './compatible';
import { $post } from '@/service/request';
import Vue from 'vue';
import { versionCompare } from '@/lib/common';
import store from '@/store';

const vm = new Vue();

class VideoService {
	constructor() {
		this.adInfo = {}; // 默认视频参数
		this.showADInfo = {}; // 加载的视频信息
		// this.preloadRewardVideo();
	}
	/** ================================== Private Methods Start ================================== */
	/**
	 * @description: 分发视频信息
	 * @return: void
	 */

	async _disPatchAdInfo() {
		const { data } = await $post('/ad/impress_for_video', {});
		return data;
	}
	/**
	 * @description: 组装视频信息
	 * @param {object} config - 配置信息
	 * @param {string} action - 模式
	 */

	_combineVideo(config, action) {
		const { sign, task_record_id, task_type } = config;
		const version = store.state.client['client-v'];

		const preloadMaster = {
			ad_id: this.adInfo.master.ad_id,
			video_type: this.adInfo.master.type,
			is_template: this.adInfo.master.is_template,
			task_id: String(task_record_id),
			sign,
			task_type,
			url_params: { ...config.url_params, ad_id: this.adInfo.master.ad_id },
		};

		const preloadFill = {
			ad_id: this.adInfo.fill.ad_id,
			video_type: 'ocean_engine_preload',
			is_template: this.adInfo.fill.is_template,
			task_id: String(task_record_id),
			sign,
			task_type,
			url_params: { ...config.url_params, ad_id: this.adInfo.fill.ad_id },
		};

		const showMaster = {
			task_type_id: String(this.adInfo.master.ad_id),
			video_type: this.adInfo.master.type,
			is_template: this.adInfo.master.is_template,
			task_record_id: Number(task_record_id),
			sign,
			task_type,
			url_params: { ...config.url_params, ad_id: this.adInfo.master.ad_id },
		};

		const showFill = {
			task_type_id: String(this.adInfo.fill.ad_id),
			video_type: this.adInfo.fill.type,
			is_template: this.adInfo.fill.is_template,
			task_record_id: Number(task_record_id),
			sign,
			task_type,
			url_params: { ...config.url_params, ad_id: this.adInfo.fill.ad_id },
		};

		const preloadMaster302 = {
			ad_id: this.adInfo.master.ad_id,
			ad_source: this.adInfo.master.type,
			is_template: this.adInfo.master.is_template,
			task_id: String(task_record_id),
			task_record_id: Number(task_record_id),
			task_desc: sign,
			task_type,
			ad_type: this.adInfo.master.video_type,
			url_params: { ...config.url_params, ad_id: this.adInfo.master.ad_id },
		};

		const preloadFill302 = {
			ad_id: this.adInfo.fill.ad_id,
			ad_source: 'ocean_engine_preload',
			is_template: this.adInfo.fill.is_template,
			task_id: String(task_record_id),
			task_record_id: Number(task_record_id),
			task_desc: sign,
			task_type,
			ad_type: this.adInfo.fill.video_type,
			url_params: { ...config.url_params, ad_id: this.adInfo.fill.ad_id },
		};

		const showMaster302 = {
			ad_id: String(this.adInfo.master.ad_id),
			ad_source: this.adInfo.master.type,
			is_template: this.adInfo.master.is_template,
			task_id: Number(task_record_id),
			task_record_id: Number(task_record_id),
			task_desc: sign,
			task_type,
			ad_type: this.adInfo.master.video_type,
			url_params: { ...config.url_params, ad_id: this.adInfo.master.ad_id },
		};
		const showFill302 = {
			ad_id: String(this.adInfo.fill.ad_id),
			ad_source: this.adInfo.fill.type,
			is_template: this.adInfo.fill.is_template,
			task_id: Number(task_record_id),
			task_record_id: Number(task_record_id),
			task_desc: sign,
			task_type,
			ad_type: this.adInfo.fill.video_type,
			url_params: { ...config.url_params, ad_id: this.adInfo.fill.ad_id },
		};

		if (action === 'preload') {
			if (versionCompare(version, '3.0.2') !== -1) {
				return {
					master: preloadMaster302,
					fill: preloadFill302,
				};
			} else {
				return {
					master: preloadMaster,
					fill: preloadFill,
				};
			}
		} else if (action === 'show') {
			if (versionCompare(version, '3.0.2') !== -1) {
				return {
					master: showMaster302,
					fill: showFill302,
				};
			} else {
				return {
					master: showMaster,
					fill: showFill,
				};
			}
		}
	}

	/** ================================== Private Methods End ================================== */

	/** ================================== Public Methods Start ================================== */
	/**
	 * @description: 预加载激励视频
	 * @param {object} config - 配置
	 * @return:
	 */

	preloadRewardVideo() {
		this._disPatchAdInfo()
			.then((res) => {
				this.adInfo = {
					master: res.master,
					fill: res.fill,
				};
				this.getVideoReward(res.ad_reward);
			})
			.catch((res) => {
				console.log(res);
			});
	}
	/**
	 * @description: 观看激励视频
	 * @param {object} config - 配置
	 * @return:
	 */

	showRewardVideo(config) {
		config = config || {};
		console.log(`showRewardVideo`, config);
		const { master, fill } = this._combineVideo(config, 'show');
		this.showADInfo = { master, fill };
		const v = store.state.client['client-v'];
		const platform = store.state.client['platform'];

		if (platform === 'Android') {
			return new Promise((resolve, reject) => {
				if (versionCompare(v, '2.9.3') !== -1) {
					if ((master.video_type && master.video_type !== 'ocean_engine') || (master.ad_source && master.ad_source !== 'ocean_engine')) {
						compatibleShowVideo(master, fill).then(
							(res) => {
								resolve(res);
							},
							(err) => {
								reject(err);
							}
						);
					} else {
						compatibleShowVideo(master, master).then(
							(res) => {
								resolve(res);
							},
							(err) => {
								reject(err);
							}
						);
					}
				} else {
					const preloadVideoInfo = this._combineVideo(config, 'preload');
					const preloadFill = preloadVideoInfo.fill;
					Object.assign(preloadFill, { video_type: 'ocean_engine' });

					setTimeout(() => {
						compatibleShowVideo(master, fill).then(
							(res) => {
								resolve(res);
							},
							(err) => {
								reject(err);
							}
						);
					}, 800);
				}
			});
		} else {
			console.log(`iOS`);
			if (versionCompare(v, '2.9.1') !== -1) {
				console.log(`大于 291 版本`);
				const masterVideoData = Object.assign(master, {
					task_type_id: master.ad_id,
					video_type: master.ad_source,
					ad_type: master.ad_source,
				});
				const fillVideoData = Object.assign(fill, { task_type_id: fill.ad_id, video_type: fill.ad_source, ad_type: master.ad_source });

				return new Promise((resolve, reject) => {
					compatibleShowVideo(masterVideoData, fillVideoData).then(
						(res) => {
							resolve(res);
						},
						(err) => {
							reject(err);
						}
					);
				});
			}
		}
	}

	/**
	 * @description: 观看视频 - 单代码位
	 * @param {object} adInfo - 激励视频代码位信息
	 * @return {Promise}
	 */

	showSingleRewardVideo(adInfo) {
		const { master, fill, task_id, task_type, app_position } = adInfo;
		const version = store.state.client['client-v'];
		let showMaster = {};
		let showFill = {};

		if (versionCompare(version, '3.0.2') !== -1) {
			showMaster = {
				...master,
				task_id,
				task_type,
				task_desc: app_position,
				url_params: { app_position, ad_id: master.ad_id },
			};
			showFill = {
				...fill,
				task_id,
				task_type,
				task_desc: app_position,
				url_params: { app_position, ad_id: fill.ad_id },
			};
		} else {
			showMaster = {
				task_type_id: String(master.ad_id),
				video_type: master.ad_source,
				is_template: master.is_template,
				task_record_id: Number(task_id),
				sign: app_position,
				task_type,
				url_params: { app_position, ad_id: master.ad_id },
			};

			showFill = {
				task_type_id: String(fill.ad_id),
				video_type: fill.ad_source,
				is_template: fill.is_template,
				task_record_id: Number(task_id),
				sign: app_position,
				task_type,
				url_params: { app_position, ad_id: fill.ad_id },
			};
		}
		return new Promise((resolve, reject) => {
			const platform = store.state.client['platform'];

			if (platform === 'ios') {
				if (versionCompare(version, '2.9.1') !== -1) {
					showMaster = Object.assign(showMaster, {
						task_type_id: showMaster.ad_id,
						task_record_id: showMaster.task_id,
						video_type: showMaster.ad_source,
					});
					showFill = Object.assign(showFill, {
						task_type_id: showFill.ad_id,
						task_record_id: showFill.task_id,
						video_type: showFill.ad_source,
					});
				}
			}
			compatibleShowVideo(showMaster, showFill)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
	/**
	 * @description: 激励视频完播埋点方法
	 */

	postVideoPlayEnd() {}
	/**
	 * @description: 获取当前视频奖励金额
	 * @param {string} reward - 奖励金额
	 * @return: void
	 */

	getVideoReward(reward) {
		vm.$bus.emit('setReward', reward);
	}
	/** ================================== Public Methods End ================================== */
}

export default new VideoService();



// WEBPACK FOOTER //
// ./src/lib/reward_video.js